function hasPermission(permissions, parentModule, childModule = null, permission) {
    const parent = permissions ?.find(mod => mod.module_name === parentModule);
    const moduleData = childModule ? parent ?.children ?.find(child => child.module_name === childModule) : parent;
    return moduleData ?.[`can_${permission}`] ?? false;
}
// Activity
export const hasDashboardPermission = (permissions, permission) =>
    hasPermission(permissions, "Dashboard", null, permission);

export const hasBranchPermission = (permissions, permission) =>
    hasPermission(permissions, "Branches", null, permission);

export const hasBranchStocksPermission = (permissions, permission) =>
    hasPermission(permissions, "Branch Stocks", null, permission);

export const hasBranchSalesPermission = (permissions, permission) =>
    hasPermission(permissions, "Branch Sales", null, permission);
	
export const hasProductPermission = (permissions, permission) =>
	hasPermission(permissions, "Products", "Product Items", permission);
	
export const hasSupplierPermission = (permissions, permission) =>
	hasPermission(permissions, "Supply Chain", "Suppliers", permission);
	
export const hasPurchasePermission = (permissions, permission) =>
	hasPermission(permissions, "Supply Chain", "Purchases", permission);
	
export const hasWarehousePermission = (permissions, permission) =>
	hasPermission(permissions, "Supply Chain", "Warehouses", permission);

export const hasDriverPermission = (permissions, permission) =>
	hasPermission(permissions, "Logistics", "Drivers", permission);

export const hasTruckPermission = (permissions, permission) =>
	hasPermission(permissions, "Logistics", "Trucks", permission);


// export const hasActivityPermission = (permissions, permission) =>
//   hasPermission(permissions, "Activities", null, permission);

// export const hasDeveloperPermission = (permissions, permission) =>
//   hasPermission(permissions, "Sales Production", "Developer", permission);

// export const hasProjectPermission = (permissions, permission) =>
//   hasPermission(permissions, "Sales Production", "Projects/Properties", permission);

// export const hasServicePermission = (permissions, permission) =>
// export const hasServicePermission = (permissions, permission) =>
//   hasPermission(permissions, "Services", "Service List", permission);



export function hasServicesPermission(permissions, module, permission) {
    const moduleData = permissions ?.find(mod => mod.module_name === "Services") ?.children ?.find(child => child.module_name === module);
    return moduleData ? moduleData[`can_${permission}`] ?? false : false;
}

// export const hasDocumentationPermission = (permissions, permission) =>
//   hasPermission(permissions, "Services", "Documentations List", permission);


// export const hasStaffPermission = (permissions, permission) =>
//   hasPermission(permissions, "Systems", "System Users", permission);

// export const hasStaffRolePermission = (permissions, permission) =>
//   hasPermission(permissions, "Systems", "Staff Roles", permission);

// export const hasModulesPermission = (permissions, permission) =>
//   hasPermission(permissions, "Systems", "System Modules", permission);

// export const hasAccountsPermission = (permissions, permission) =>
//   hasPermission(permissions, "Sales Production", "Account Data", permission);